import { Injectable, NgZone } from "@angular/core";
import { MatSnackBar, MatSnackBarConfig } from "@angular/material/snack-bar";
/**
 * Provides an interface to show up diferent popups
 */
@Injectable({ providedIn: "root" })
export class NotificationService {
  constructor(
    private readonly snackBar: MatSnackBar,
    private readonly zone: NgZone
  ) { }
  /**
   * Default message
   * @param message
   */
  default(message: string): void {
    this.show(message, {
      duration: 2000,
      panelClass: "default-notification-overlay"
    });
  }
  /**
   * Information message
   * @param message
   */
  info(message: string): void {
    this.show(message, {
      duration: 2000,
      panelClass: "info-notification-overlay"
    });
  }
  /**
   * Action successful message
   * @param message
   */
  success(message: string): void {
    this.show(message, {
      duration: 2000,
      panelClass: "success-notification-overlay"
    });
  }
  /**
   * Warning message
   * @param message
   */
  warn(message: string): void {
    this.show(message, {
      duration: 2500,
      panelClass: "warning-notification-overlay"
    });
  }
  /**
   * Error message
   * @param message
   */
  error(message: string): void {
    this.show(message, {
      duration: 4000,
      panelClass: "error-notification-overlay"
    });
  }
  /**
   * Launch de popup with predefined options
   * @param message
   * @param configuration
   */
  private show(message: string, configuration: MatSnackBarConfig) {
    this.zone.run(() => this.snackBar.open(message, null, configuration));
  }
}
